module.exports = __webpack_public_path__ + "img/asset_ok_on.a14e0e01.svg";